import React from "react";
import { Store, CheckCircle2, CalendarDays, Trash2 } from "lucide-react";

const fmtRange = (ini, fim) => {
  const f = (d) => {
    if (!d) return "";
    const [, m, dia] = d.split("-");
    return `${dia}/${m}`;
  };
  return `${f(ini)} - ${f(fim)}`;
};

export default function WeeklyGoalCard({ meta, vendas, progresso, atingida, fmt, onOpenDaily, onDelete }) {
  return (
    <div
      className="relative flex flex-col p-6 bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300 transition-all duration-200 cursor-pointer group"
      onClick={() => onOpenDaily(meta)}
      data-testid={`weekly-goal-card-${meta.id}`}
    >
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-xl transition-colors ${atingida ? "bg-emerald-50 text-emerald-600" : "bg-slate-50 text-slate-600 group-hover:bg-blue-50 group-hover:text-blue-600"}`}>
            <Store className="w-5 h-5" />
          </div>
          <div>
            <h3 className="text-lg font-semibold tracking-tight text-slate-800 leading-tight">{meta.loja}</h3>
            <span className="text-xs font-medium uppercase tracking-wider text-slate-400 flex items-center gap-1">
              <CalendarDays className="w-3 h-3" /> {fmtRange(meta.data_inicio, meta.data_fim)}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${atingida ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-blue-50 text-blue-700 border-blue-200"}`}>
            {atingida && <CheckCircle2 className="w-3 h-3" />}
            {progresso}%
          </span>
        </div>
      </div>

      <div className="mb-4 space-y-1">
        <p className="text-xs font-medium uppercase tracking-wider text-slate-400">Vendas na semana</p>
        <p className="text-3xl font-black tracking-tighter text-slate-900">{fmt(vendas)}</p>
        <p className="text-sm text-slate-500">
          Meta: <span className="font-semibold text-slate-700">{fmt(meta.valor_meta)}</span>
        </p>
      </div>

      <div className="mt-auto flex items-center gap-3">
        <div className="h-2.5 flex-1 bg-slate-100 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-500 ease-out ${atingida ? "bg-emerald-500" : "bg-blue-500"}`}
            style={{ width: `${progresso}%` }}
          />
        </div>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onDelete(meta.id); }}
          className="p-1.5 rounded-lg text-slate-400 hover:text-rose-500 hover:bg-rose-50 opacity-0 group-hover:opacity-100 transition-all"
          data-testid={`weekly-goal-delete-${meta.id}`}
          title="Excluir meta"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
